export interface Auth {
  role: ROLE;
  username: string;
  fullName: string;
}

export enum ROLE {
  DOCTOR = 'DOCTOR',
  ADMIN = 'ADMIN',
  USER = 'USER'
}
